import React, { useState, useEffect, useRef } from "react";
import gearIcon from "./img/gear.png";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form } from "react-bootstrap";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
registerLocale("de", de);

export default function NutzerauswertungsOptionen({
   getData,
   initOptionen,
   userObjects,
   benutzerOptionen,
   setBenutzerOptionen,
   getNotarTermine,
   initialshow,
   placement,
   timeLimits,
   setTimeLimits,
}) {
   const [show, setShow] = useState(initialshow);

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);

   function addToUserList(e) {
      setBenutzerOptionen((prev) => ({ ...prev, [e.target.value]: true }));
   }

   useEffect(() => {
      localStorage.setItem("pUserOpt", JSON.stringify(benutzerOptionen));
   }, [benutzerOptionen]);

   return (
      <div className="projektstatus-optionen">
         <button onClick={handleShow}>
            <img src={gearIcon} width="26px" />
         </button>

         <Offcanvas show={show} onHide={handleClose} placement={placement ? placement : "bottom"}>
            <Offcanvas.Header closeButton></Offcanvas.Header>
            <Offcanvas.Body>
               <div className="optionen">
                  
                   {userObjects && (
                     <><div>
                        Wessen Daten sollen angezeigt werden (Einkauf)?
                        <Form className="mt-2 mb-2">
                           <Form.Select value={""} onChange={(e) => addToUserList(e)}>
                              <option></option>
                              {Object.keys(userObjects).filter(item=>userObjects[item].Sonstiges.toLowerCase().includes("einkauf"))
                                 .sort((a, b) => {
                                    if (userObjects[a].Nachname + userObjects[a].Vorname < userObjects[b].Nachname + userObjects[b].Vorname)
                                       return -1;
                                    if (userObjects[a].Nachname + userObjects[a].Vorname > userObjects[b].Nachname + userObjects[b].Vorname)
                                       return 1;
                                    return 0;
                                 })
                                 .map((user) => (
                                    <option key={"userOpt_" + user} value={user}>
                                       {userObjects[user].Nachname + " " + userObjects[user].Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form>
                        
                     </div>
                     <div>
                        Wessen Daten sollen angezeigt werden (Verkauf)?
                        <Form className="mt-2 mb-2">
                           <Form.Select value={""} onChange={(e) => addToUserList(e)}>
                              <option></option>
                              {Object.keys(userObjects).filter(item=>userObjects[item].Sonstiges.toLowerCase().includes("verkauf"))
                                 .sort((a, b) => {
                                    if (userObjects[a].Nachname + userObjects[a].Vorname < userObjects[b].Nachname + userObjects[b].Vorname)
                                       return -1;
                                    if (userObjects[a].Nachname + userObjects[a].Vorname > userObjects[b].Nachname + userObjects[b].Vorname)
                                       return 1;
                                    return 0;
                                 })
                                 .map((user) => (
                                    <option key={"userOpt_" + user} value={user}>
                                       {userObjects[user].Nachname + " " + userObjects[user].Vorname}
                                    </option>
                                 ))}
                           </Form.Select>
                        </Form>
                        {Object.keys(benutzerOptionen).map((selecteduser) => (
                           <button
                              key={"selectedUserOpt_" + selecteduser}
                              className="benutzer-button"
                              name={selecteduser}
                              onClick={(e) =>
                                 setBenutzerOptionen((prev) => {
                                    const newBenutzerOptionen = structuredClone(prev);
                                    delete newBenutzerOptionen[selecteduser];
                                    return newBenutzerOptionen;
                                 })
                              }
                           >
                              {userObjects[selecteduser].Nachname + " " + userObjects[selecteduser].Vorname} ×
                           </button>
                        ))}
                     </div>
                     </>
                  )}
                  {timeLimits && (
                     <div>
                        <Form.Group controlId={"id_date1"} className="mb-3" title={"von"}>
                           <Form.Label>von</Form.Label>
                           <DatePicker
                              isClearable
                              selected={timeLimits.start ? timeLimits.start : false}
                              timeIntervals={5}
                              onChange={(e) => {
                                 const newTimelimits = { ...timeLimits, start: e };
                                 localStorage.setItem("nutzerauswertungTimelimits", JSON.stringify(newTimelimits));
                                 setTimeLimits(newTimelimits);
                              }}
                              className={"bootstrap-datepicker"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="dd.MM.yyyy"
                              locale="de"
                           />
                           <Form.Label>bis</Form.Label>
                           <DatePicker
                              isClearable
                              selected={timeLimits.end ? timeLimits.end : false}
                              timeIntervals={5}
                              onChange={(e) => {
                                 const newTimelimits = { ...timeLimits, end: e };
                                 localStorage.setItem("nutzerauswertungTimelimits", JSON.stringify(newTimelimits));
                                 setTimeLimits(newTimelimits);
                              }}
                              className={"bootstrap-datepicker"}
                              calendarClassName="custom-date-calendar"
                              dateFormat="dd.MM.yyyy"
                              locale="de"
                           />
                        </Form.Group>
                     </div>
                  )}
                  <div /* style={{ textAlign: "center" }} */>
                     Nach dem Ändern der anzuzeigenden Daten:
                     <br />
                     <Button style={{ width: "280px" }} onClick={() => getData()}>
                        aktualisieren
                     </Button>{" "}
                  </div>
                  
               </div>
            </Offcanvas.Body>
         </Offcanvas>
      </div>
   );
}
